<div class="container p-5">
  <div class="text-center mb-5" *ngIf="statusSignal() === 'confirmed'; else pendingOrFailed">
    <h3 class="mb-4">Your Subscription Is Confirmed!</h3>
    <p class="lead mb-4">
      Stripe webhook confirmation was received, and your account is now active.
    </p>

    <h5 class="mb-4">
      Redirecting you to the dashboard in
      <span class="badge bg-success"><strong>{{ countdown }}</strong></span>
      seconds...
    </h5>

    <div class="row p-4 justify-content-center">
      <div class="col-md-4">
        <a routerLink="/dashboard" routerLinkActive="active" class="btn btn-primary btn-lg w-100">
          <i class="bi bi-grid-1x2-fill"></i> Go To Dashboard
        </a>
      </div>
    </div>
  </div>

  <ng-template #pendingOrFailed>
    <div class="text-center mb-5" *ngIf="statusSignal() === 'pending'; else failedState">
      <h3 class="mb-4">Finalizing Your Subscription</h3>
      <p class="lead mb-3">We're waiting for Stripe webhook confirmation before activating your plan.</p>
      <p class="text-muted mb-4">
        This usually takes a few seconds. You can stay on this page while we keep checking.
      </p>

      <div class="alert alert-info d-inline-flex align-items-center gap-2" role="alert">
        <i class="bi bi-hourglass-split"></i>
        <span>Payment status: {{ paymentSignal()?.status || 'pending' }}</span>
      </div>

      <div class="mt-4">
        <a routerLink="/dashboard" class="btn btn-outline-secondary">Go to Dashboard</a>
      </div>
    </div>
  </ng-template>

  <ng-template #failedState>
    <div class="text-center mb-5">
      <h3 class="mb-3">We couldn't confirm your payment</h3>
      <p class="text-muted mb-4">
        Please return to checkout and try again. If you've already been charged, contact support with payment ID
        <strong>{{ paymentId || 'N/A' }}</strong>.
      </p>
      <div class="d-flex justify-content-center gap-2 flex-wrap">
        <a routerLink="/checkout" class="btn btn-primary">Back to Checkout</a>
        <a routerLink="/dashboard" class="btn btn-outline-secondary">Go to Dashboard</a>
      </div>
    </div>
  </ng-template>
</div>
